import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackAuthenticationCompletedSpec,
  trackBookDemoCliniciansSelectedSpec,
  trackBookDemoCountrySelectedSpec,
  trackBookDemoFormSubmittedSpec,
  trackBookDemoNextClickedSpec,
  trackCoachMarkActionTakenSpec,
  trackCoachMarkViewedSpec,
  trackContactSalesFormOpenedSpec,
  trackContactSalesFormSubmittedSpec,
  trackDemoCompletedSpec,
  trackDemoStartedSpec,
  trackErrorViewedSpec,
  trackOnboardingCompletedSpec,
  trackOnboardingErrorViewedSpec,
  trackOnboardingStartedSpec,
  trackOnboardingStepCompletedSpec,
  trackOnboardingStepSkippedSpec,
  trackOnboardingUpdatedSpec,
  trackOrganisationSurveySubmittedSpec,
  trackProductTourViewedSpec,
  type AuthenticationCompleted,
  type BookDemoCliniciansSelected,
  type BookDemoCountrySelected,
  type BookDemoFormSubmitted,
  type BookDemoNextClicked,
  type CoachMarkActionTaken,
  type CoachMarkViewed,
  type ContactSalesFormOpened,
  type ContactSalesFormSubmitted,
  type DemoCompleted,
  type DemoStarted,
  type ErrorViewed,
  type OnboardingCompleted,
  type OnboardingErrorViewed,
  type OnboardingStarted,
  type OnboardingStepCompleted,
  type OnboardingStepSkipped,
  type OnboardingUpdated,
  type OrganisationSurveySubmitted,
  type ProductTourViewed,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const onboardingEvents: SnowplowEventMap = {
  [TrackingEventName.OnboardingStarted]: (props) =>
    trackOnboardingStartedSpec(props as OnboardingStarted),
  [TrackingEventName.OnboardingCompleted]: (props) =>
    trackOnboardingCompletedSpec(props as OnboardingCompleted),
  [TrackingEventName.AuthenticationCompleted]: (props) =>
    trackAuthenticationCompletedSpec(props as AuthenticationCompleted),
  [TrackingEventName.OnboardingStepCompleted]: (props) =>
    trackOnboardingStepCompletedSpec(props as OnboardingStepCompleted),
  [TrackingEventName.OnboardingStepSkipped]: (props) =>
    trackOnboardingStepSkippedSpec(props as OnboardingStepSkipped),
  [TrackingEventName.OnboardingUpdated]: (props) =>
    trackOnboardingUpdatedSpec(props as OnboardingUpdated),
  [TrackingEventName.BookDemoCliniciansSelected]: (props) =>
    trackBookDemoCliniciansSelectedSpec(props as BookDemoCliniciansSelected),
  [TrackingEventName.BookDemoCountrySelected]: (props) =>
    trackBookDemoCountrySelectedSpec(props as BookDemoCountrySelected),
  [TrackingEventName.BookDemoFormSubmitted]: (props) =>
    trackBookDemoFormSubmittedSpec(props as BookDemoFormSubmitted),
  [TrackingEventName.BookDemoNextClicked]: (props) =>
    trackBookDemoNextClickedSpec(props as BookDemoNextClicked),
  [TrackingEventName.CoachMarkActionTaken]: (props) =>
    trackCoachMarkActionTakenSpec(props as CoachMarkActionTaken),
  [TrackingEventName.CoachMarkViewed]: (props) =>
    trackCoachMarkViewedSpec(props as CoachMarkViewed),
  [TrackingEventName.ContactSalesFormOpened]: (props) =>
    trackContactSalesFormOpenedSpec(props as ContactSalesFormOpened),
  [TrackingEventName.ContactSalesFormSubmitted]: (props) =>
    trackContactSalesFormSubmittedSpec(props as ContactSalesFormSubmitted),
  [TrackingEventName.DemoCompleted]: (props) =>
    trackDemoCompletedSpec(props as DemoCompleted),
  [TrackingEventName.DemoStarted]: (props) => trackDemoStartedSpec(props as DemoStarted),
  [TrackingEventName.ProductTourViewed]: (props) =>
    trackProductTourViewedSpec(props as ProductTourViewed),
  [TrackingEventName.OrganisationSurveySubmitted]: (props) =>
    trackOrganisationSurveySubmittedSpec(props as OrganisationSurveySubmitted),
  [TrackingEventName.OnboardingErrorViewed]: (props) =>
    trackOnboardingErrorViewedSpec(props as OnboardingErrorViewed),
  [TrackingEventName.ErrorViewed]: (props) => trackErrorViewedSpec(props as ErrorViewed),
};
